import gql from 'graphql-tag'

export default gql`
  fragment DraftPostMedia on DraftPost {
    media {
      id
      coverUrl
      mimeType
      url
    }
  }
`
